<template>
  <div class="service">
    <router-link
      v-for="(item, index) in list"
      :key="index"
      :to="{ path: '/detail', query: { api: 'server_details', id: item.id } }"
      tag="div"
      :style="{
        backgroundImage: 'url(' + item.img + ')',
      }"
      :class="{ show: show == index }"
      @mouseenter.native="show = index"
    >
      <img src="../assets/mask.png" alt="" />
      <p class="title">{{ item.title }}</p>
      <p class="sub-title">{{ item.en_title }}</p>
      <span class="radius"></span>
      <router-link to="" tag="span" class="more"
        >MORE <i class="el-icon-arrow-right"></i
      ></router-link>
    </router-link>
  </div>
</template>

<script>
import { server } from '../utils/api'
export default {
  data() {
    return {
      list: [],
      show: 0,
    }
  },
  created() {
    server((r) => {
      this.list = r.data
    })
  },
}
</script>

<style lang="less" scoped>
@keyframes o {
  0% {
    transform: translate(-50%, -50%) scaleX(1) scaleY(1);
    opacity: 1;
  }
  25% {
    opacity: 0;
  }
  50% {
    transform: translate(-50%, -50%) scaleX(1.25) scaleY(1.25);
    opacity: 1;
  }
  75% {
    opacity: 0;
  }
  100% {
    transform: translate(-50%, -50%) scaleX(1.5) scaleY(1.5);
    opacity: 1;
  }
}
.service {
  display: flex;
  width: 100%;
  & > div.show {
    flex: unset;
    width: 570px;
    position: relative;
    .more {
      font-size: 20px;
      margin-top: 40px;
    }

    .title,
    .sub-title {
      opacity: 1;
    }
    .radius {
      display: inline-block;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translateX(-50%), translateY(-50%);
    }
    .radius::before {
      content: '';
      width: 158px;
      height: 158px;
      border: 1px solid #c8c8c8;
      border-radius: 50%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      animation: o 2s linear infinite;
    }
    .radius::after {
      content: '';
      width: 118px;
      height: 118px;
      border: 1px solid #c8c8c8;
      border-radius: 50%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      animation: o 2s linear infinite;
    }
  }
  & > div {
    height: 100vh;
    display: flex;
    width: 25%;
    transition: all 0.15s linear;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    background-attachment: local;
    background-position: center;
    cursor: pointer;
    background-size: 580px auto;
    background-repeat: no-repeat;
    img {
      transition: all 0.15s linear;
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
    }
    .title {
      font-size: 34px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #ffffff;
      margin-bottom: 6px;
      position: relative;
      width: 8em;
      overflow: hidden;
      white-space: nowrap;
      // text-overflow: ellipsis;
      text-align: center;
      opacity: 0;
    }
    .sub-title {
      font-size: 18px;
      font-family: Arial;
      font-weight: 400;
      color: #ededed;
      width: 80%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      text-align: center;
      opacity: 0;
    }
    .more {
      font-size: 0;
      font-family: Arial;
      font-weight: 400;
      color: #ededed;
      margin-top: 0;
      display: inline-block;
      height: 0;
      transition: all 0.15s linear;
    }
  }
}

@media (max-width: 767px) {
  .service {
    display: block;
    & > div.show{
      width: 100%;
    }
    & > div {
      width: 100%;
      background-size: cover;
      background-attachment: unset;
      .title {
        font-size: 0.48rem;
        opacity: 1;
      }
      .sub-title {
        font-size: 0.24rem;
        opacity: 1;
      }
      .radius::before {
        content: '';
        width: 1.58rem;
        height: 1.58rem;
        border: 1px solid #c8c8c8;
        border-radius: 50%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        animation: o 2s linear infinite;
      }
      .radius::after {
        content: '';
        width: 1.18rem;
        height: 1.18rem;
        border: 1px solid #c8c8c8;
        border-radius: 50%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        animation: o 2s linear infinite;
      }
      .more {
        font-size: 0.28rem;
        margin-top: 0.48rem;
      }
    }
  }
}
</style>